<style lang="scss"
       module>
@import 'src/brand/brandColors';
@import 'src/brand/structure.variables';
@import 'src/brand/typography.variables';

.fullSolution {
  position: absolute;
  color: $white;
  z-index: 1;
  width: calc(100% - (2 * #{$column-inset}));
  height: calc(35rem + #{$desktop-gutter});
  cursor: pointer;
}

.solution {
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.topContent {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.contentArea {
  font-family: $font-stack-condensed;
  -webkit-font-smoothing: antialiased;
  font-size: 1.8rem;
  line-height: 2.2rem;
  width: 100%;
  min-height: 17.5rem;
  margin-right: $desktop-gutter;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  &:last-of-type {
    margin-right: 0;
  }
}

.leftContent {
  composes: contentArea;
  justify-content: flex-end;
  padding: 2 * $mobile-spacing $mobile-spacing $mobile-spacing $mobile-spacing;
}

.rightContent {
  composes: contentArea;
  justify-content: center;
  text-align: center;
  padding: 2 * $mobile-spacing $mobile-spacing $mobile-spacing $mobile-spacing;
}

.left {
  width: 100%;
  height: 100%;
  background: $blue;
}

.leftOrange {
  composes: left;
  background: $orange;
}

.right {
  width: 100%;
  height: 100%;
  background: $blue;
}

.rightOrange {
  composes: right;
  background: $orange;
}

.headline {
  font-family: $font-stack-condensed;
  -webkit-font-smoothing: antialiased;
  font-size: 2.8rem;
  line-height: 2.4rem;
  font-weight: 700;
  color: $white;
  text-transform: uppercase;
  text-align: center;
}

.subheadline {
  font-family: $font-stack-condensed;
  -webkit-font-smoothing: antialiased;
  font-size: 1.8rem;
  line-height: 1.8rem;
  font-weight: 700;
  color: $white;
  text-align: center;
}

.icon {
  width: 2rem;
  min-height: 2rem;
  margin-top: 2 * $mobile-spacing;
  margin-bottom: $mobile-spacing;
}

.bottomContent {
  font-family: $font-stack-condensed;
  -webkit-font-smoothing: antialiased;
  font-size: 1.8rem;
  line-height: 2.2rem;
  width: 100%;
  background: $gray;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<template>
  <div
    :class="$style.fullSolution"
    @click="close">
    <div
      v-if="isLeft"
      :class="[isBlue ? $style.left : $style.leftOrange]">
      <div :class="$style.solution">
        <div :class="$style.topContent">
          <div :class="$style.leftContent">
            <div :class="$style.headline">{{ head }}:</div>
            <div :class="$style.subheadline">{{ subhead }}</div>
            <img
              :class="$style.icon"
              src="minus.svg"
              alt=""></div>
          <div :class="$style.rightContent">{{ content }}</div>
        </div>
        <div :class="$style.bottomContent">
          {{ stat }}
        </div>
      </div>
    </div>
    <div
      v-else
      :class="[isBlue ? $style.right : $style.leftOrange]">
      <div :class="$style.solution">
        <div :class="$style.topContent">
          <div :class="$style.rightContent">{{ content }}</div>
          <div :class="$style.leftContent">
            <div :class="$style.headline">{{ head }}:</div>
            <div :class="$style.subheadline">{{ subhead }}</div>
            <img
              :class="$style.icon"
              src="minus.svg"
              alt=""></div>
        </div>
        <div :class="$style.bottomContent">
          {{ stat }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* Vue Components */
/* Meteor packages */
/* NPM packages */
/* Methods */
/* Everything else */

export default {
  name: 'SolutionOpen',
  props: {
    modalTop: {
      type: Number,
      required: true,
    },
    modalLeft: {
      type: Number,
      required: true,
    },
    head: {
      type: String,
      required: true,
    },
    subhead: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
    stat: {
      type: String,
      required: true,
    },
    isBlue: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isLeft: true,
    };
  },
  watch: {
    modalTop() {
      this.$el.style.top = `${this.modalTop}px`;
    },
    modalLeft() {
      this.isLeft = this.modalLeft <= 100;
    },
  },
  mounted() {
    this.$el.style.top = `${this.modalTop}px`;
    this.isLeft = this.modalLeft <= 100;
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
